import React from 'react';
import css from '../../ProfilePage.module.css';

function CredentialCard({ title, data, withYear = false }) {
  if (!data || data.length === 0) return null;

  return (
    <div className={css.credentialCard}>
      <div className={css.certificationsHeading}>{title}</div>
      <div className={css.credentialDetails}>
        {data?.map((item, index) => (
          <div key={index} className={css.credentialContent}>
            <div className={css.credentialTitle}>
              • {item.name}
              {withYear && item.year && (
                <div className={css.credentialYear}> {item.year}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


export default CredentialCard;
